module.exports = __webpack_public_path__ + "static/media/class_job_015.7191089d.svg";